<template>
    <v-col cols="12" lg="12" md="12" sm="12">
        <v-select v-model="form.phone.phone_sys_reason" density="compact" variant="outlined" label="Which best describes your phone system needs?" :items="[{title:'---',value:null},'Installing A New Phone System','Replacing Existing Phone System','Expanding Existing Phone System']"/>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
